<template>
	<BaseTable
		sticky-header
		no-grid-options="true"
		:show-footer="false"
		style="box-shadow:none; margin: 0;"
	>
		<ListTransition
			:class="$style['products__content']"
			:time-in="90"
			tag="div"
		>
			<template v-if="loading.cartProducts">
				<RowSkeleton
					v-for="product in 10"
					:key="product"
					:columns="filteredColumns"
				/>
			</template>
			<template v-if="!loading.cartProducts">
				<ProductRow
					v-for="product in products"
					:key="product.recarId"
					:product="product"
					:delete-func="deleteFunc"
					:update-func="updateFunc"
					:checked="!!selected.find(_product => _product.id === product.id)"
					:value="product.recarId"
					:columns="filteredColumns"
					@remove-part="handleRemovePart($event)"
					@checkbox="selectRow"
				/>
			</template>
		</ListTransition>
		<BaseTableRow
			v-if="data.length === 0 && !loading"
			:clean="true"
			:class="$style['products__spinner']"
			style="padding: 20px;"
		>
			Krepšelis tuščias
		</BaseTableRow>
	</BaseTable>
</template>

<script>
import ListTransition from '@/components/Transitions/ListTransistion'
import RowSkeleton from './RowSkeleton'
import {
	mapGetters,
	mapMutations
} from '@/store/modules/App/Cart/helpers'
import * as TABLE_MUTATIONS from '@/store/modules/Table/mutation-types'
import ProductRow from './ProductRow'

export default {
	components: {
		ListTransition,
		RowSkeleton,
		ProductRow
	},

	props: {
		products: {
			type: Array,
			default: () => []
		},
		deleteFunc: {
			type: Function,
			required: true
		},
		updateFunc: {
			type: Function,
			required: true
		},
		requesting: {
			type: Boolean,
			default: false
		},
		page: {
			type: [String, Number],
			default: 1
		},
		perPage: {
			type: [String, Number],
			default: 5
		}
	},

	computed: {

		...mapGetters({
			loading: 'loading',
			meta: 'meta',
			data: 'fullParts',
			selected: 'Table/selected',
			columns: 'Table/columns',
			sortBy: 'Table/sortBy'
		}),

		filteredColumns () {
			if (!this.$can('PARTS_QUANTITY_DISABLED')) {
				return [
					...this.columns,
					{
						name: 'quantity.',
						tag: 'quantity',
						sortKey: 'quantity',
						span: 0.7
					}
				]
			}
			return this.columns
		}
	},
	created () {

		this.setColumns([	{
			name: 'name',
			tag: 'category',
			sortKey: 'category',
			widthPreset: 'media',
			span: 1.5
		}])
	},

	methods: {
		...mapMutations({
			setColumns: `Table/${TABLE_MUTATIONS.SET_COLUMNS}`,
			setSortBy: `Table/${TABLE_MUTATIONS.SET_SORT_BY}`,
			setSelected: `Table/${TABLE_MUTATIONS.SET_SELECTED}`,
			clearData: `Table/${TABLE_MUTATIONS.CLEAR_DATA}`,
			clearSelected: `Table/${TABLE_MUTATIONS.CLEAR_SELECTED}`
		}),

		handleRemovePart (id) {
			this.setFullParts(this.data.filter(product => product.id !== id))
		},

		selectRow (e) {
			e.stopPropagation()
			let selected = [...this.selected]
			let product = this.data.find(product => product.id === e.target.value)
			const checked = e?.target ? e.target.checked : e
			if (!checked) {
				selected = selected.filter(_product => _product.id !== product.id)
			} else {
				selected.push(product)
			}
			this.setSelected(selected)
		},

		selectAll (e) {
			const checked = e?.target ? e.target.checked : e
			if (!checked) {
				this.clearSelected()
			} else {
				this.setSelected(this.data)
			}
		}
	}
}
</script>

<style lang="scss" module>
.products {
        &__spinner {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 20px 0;
			border: none;
        }
    }
</style>
